export default __webpack_public_path__ + "static/media/test_label.47c0f0a3.png";